import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webapp-banner',
  templateUrl: './webapp-banner.component.html',
  styleUrls: ['./webapp-banner.component.css']
})
export class WebappBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
